import api from "store/api"

export const withdrawApplication = (moreData) => {
  const { boardId, applicationId } = moreData
  let data = { status_id: moreData?.status_id }
  return api
    .put(`/app/boards/${boardId}/application/${applicationId}`, data)
    .then((res) => res.data.data)
}
